import { SessionHelper } from "../helpers/sessionHelper";
import store from "../store/store";
import type { NavigationMetaType } from "../types/navigationType";
export default class NavigationLogic {
  static updateNavigationTree(navigationUpdate: any) {
    const navigationTree = navigationUpdate.trees;
    store.dispatch.navigationModel.updateNavigationTree({
      navigationTree,
    });
  }

  static updateFiltering(
    selectedNavNodeIds: number[],
    selectedSport?: NavigationMetaType,
    selectedCountry?: NavigationMetaType,
    selectedCompetition?: NavigationMetaType
  ) {
    // convert array of tag ids to comma separated string
    const navNodeIds = selectedNavNodeIds.join(",");
    // Update the filtering params
    store.dispatch.navigationModel.updateFiltering({
      navNodeIds,
      selectedSport,
      selectedCountry,
      selectedCompetition,
    });
    // Fire a call to set new event list
    // store.dispatch.eventListModel.setEventList();
  }

  static updateFilteringCompetitions(
    selectedNavNodeIds: number[],
    selectedSport?: NavigationMetaType,
    selectedCountry?: NavigationMetaType,
    selectedCompetition?: NavigationMetaType
  ) {
    // convert array of tag ids to comma separated string
    const navNodeIds = selectedNavNodeIds.join(",");
    // Update the filtering params
    store.dispatch.navigationModel.updateFiltering({
      navNodeIds,
      selectedSport,
      selectedCountry,
      selectedCompetition,
    });
    // update singleCompetitionOnly to false
    SessionHelper.setSingleCompetitionOnly(false);
    // remove single competition id if stored
    SessionHelper.removeSingleCompetitionOnlyId();
    // reset competition list before getting a new list
    store.dispatch.competitionListModel.resetCompetition();
    // Fire a call to set new event list
    store.dispatch.competitionListModel.setEuroCompetitionList();
  }

  static updateFilteringSingleCompetitions(
    selectedNavNodeIds: number[],
    selectedSport?: NavigationMetaType,
    selectedCountry?: NavigationMetaType,
    selectedCompetition?: NavigationMetaType,
    activeEventId?: number
  ) {
    // convert array of tag ids to comma separated string
    const navNodeIds = selectedNavNodeIds.join(",");
    // Update the filtering params
    store.dispatch.navigationModel.updateFiltering({
      navNodeIds,
      selectedSport,
      selectedCountry,
      selectedCompetition,
    });
    // update singleCompetitionOnly to true
    SessionHelper.setSingleCompetitionOnly(true);
    // save competition id to session storage
    SessionHelper.storeSingleCompetitionOnlyId(
      selectedCompetition && selectedCompetition.id
    );
    // update filter tab to all for single competition selected
    store.dispatch.competitionsListFiltersModel.updateCompetitionListType(
      "ALL"
    );
    // override to stop  append compeitions to list
    // store.dispatch.competitionListModel.doNotAppendCompetitionList(true);
    // Fire a call to set new event list
    let params = {};

    if (activeEventId) {
      params.activeEventId = activeEventId;
    }

    store.dispatch.competitionListModel.setSingleCompetitionList(params);
  }
}
